import {
  SALVAR_LISTA_PRODUTOS,
  SALVAR_TIPO_VEICULO,
  SALVAR_DADOS_USUARIO,
  ONDE_USAR,
  RECEBER_ADESIVO,
  SALVAR_VALOR_RECARGA,
  ONDE_RECEBER,
  TIPO_PAGAMENTO,
  SALVAR_DESCONTO,
  TOTAL_PRODUTOS,
  SAVE_CAPTCHA,
  SALVAR_CODIGO_PROMOCIONAL,
  RESET_TIPO_PAGAMENTO,
  SALVAR_DADOS_VEICULO,
  FEATURE_FLAG_TAG_ATIVA,
} from '../../actions/pedidoActions';
import { initialState } from './initialState';

const pedido = (state = initialState, action) => {
  switch (action.type) {
    case SALVAR_DADOS_USUARIO:
      return { ...state, dadosUsuario: action.dadosUsuario };
    case SALVAR_LISTA_PRODUTOS:
      return { ...state, listaDeProdutos: action.listaDeProdutos };
    case SALVAR_TIPO_VEICULO:
      return { ...state, tipoVeiculo: action.tipoVeiculo, listaDeProdutos: [] };
    case ONDE_USAR:
      return { ...state, ondeUsar: action.ondeUsar };
    case RECEBER_ADESIVO:
      return { ...state, receberAdesivo: action.receberAdesivo };
    case ONDE_RECEBER:
      return { ...state, dadosEndereco: action.dadosEndereco };
    case TIPO_PAGAMENTO:
      return { ...state, tipoPagamento: action.tipoPagamento };
    case RESET_TIPO_PAGAMENTO:
      return { ...state, tipoPagamento: '' };
    case SALVAR_VALOR_RECARGA:
      return { ...state, valorRecarga: action.valorRecarga };
    case SALVAR_DESCONTO:
      return { ...state, cupomDesconto: action.cupomDesconto };
    case TOTAL_PRODUTOS:
      return { ...state, totalProdutos: action.infoTotal };
    case SAVE_CAPTCHA:
      return { ...state, captchaResponse: action.captchaResponse };
    case SALVAR_CODIGO_PROMOCIONAL:
      return { ...state, codigoPromocional: action.codigoPromocional };
    case SALVAR_DADOS_VEICULO:
      return { ...state, dadosVeiculo: action.dadosVeiculo };
    case FEATURE_FLAG_TAG_ATIVA:
      return { ...state, featureFlag: action.featureFlag };
    case 'loader_active':
      return { ...state, loader_active: true };
    case 'loader_inactive':
      return { ...state, loader_active: false };
    default:
      return state;
  }
};

export default pedido;
